module.exports = __webpack_public_path__ + "static/media/man-users.6568218b.svg";